import gql from 'graphql-tag';
import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'ListingCancellationPolicy';

const listingCancellationPolicyQuery = gql`
query ${OPERATION_NAME}($listingId: String! $unitUrl: String $arrivalDate: String) {
    listing(
        listingId: $listingId
        unitApiUrl: $unitUrl
        arrivalDate: $arrivalDate) {
        integratedPropertyManager
        cancellationPolicy {
            policyType
            cancellationPolicyPeriods{
                label
            }
            cancellationPolicyLabel {
                label
                date
                isFullRefundWindow
            }
            cancellationTimelinePeriods {
                timelineLabel
                refundPercent
                refundWindowLabel
                shortDateLocalized
                isPast
                isActive
                iconCode
            }
        }
    }
}`;

async function listingCancellationPolicyGraphQl({locale, unitUrl, listingId, arrivalDate}) {
    try {
        return await graphqlQuery(
            OPERATION_NAME,
            listingCancellationPolicyQuery,
            {listingId, unitUrl, arrivalDate},
            locale
        );
    } catch (e) {
        return null;
    }
}

export default listingCancellationPolicyGraphQl;
export {listingCancellationPolicyGraphQl, OPERATION_NAME, listingCancellationPolicyQuery};
